import type { QueryClient } from '@tanstack/react-query'

import { playerRelationshipQueryOptions } from './query-options'

export const playerRelationshipRouteOptions = {
  loader: ({ context, params }: {
    context: { queryClient: QueryClient }
    params: { playerId: string }
  }) => {
    const playerId = Number(params.playerId)
    if (Number.isInteger(playerId) && playerId > 0) {
      void context.queryClient.prefetchQuery(playerRelationshipQueryOptions(playerId))
    }
  },
}
